/**
 * Dev-only logger. Silently no-ops in production builds.
 * Use this instead of `console.error` so we surface failures during development
 * without leaking internals or cluttering production logs.
 */
const isDev = process.env.NODE_ENV !== 'production';

export const devLog = {
  error: (...args) => { if (isDev) console.error(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};
